import { useNavigate, useParams } from 'react-router';
import { usePortfolioDetailQuery } from '@/entities/portfolio';
import { PortfolioEditorForm } from '@/features/portfolio-editor';
import { Button } from '@/shared/ui';

export const PortfolioEditorPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const detail = usePortfolioDetailQuery(id);
  if (id && detail.isPending) return <p>포트폴리오를 불러오는 중…</p>;
  if (id && !detail.data)
    return (
      <div className="space-y-3">
        <p role="alert">포트폴리오를 불러오지 못했습니다.</p>
        <Button type="button" variant="outline" onClick={() => void detail.refetch()}>
          다시 불러오기
        </Button>
      </div>
    );
  return (
    <PortfolioEditorForm
      key={id ?? 'new'}
      initialValue={id ? detail.data : undefined}
      onSaved={() => navigate('/portfolio', { state: { message: '포트폴리오를 저장했습니다.' } })}
      onCancel={() => navigate('/portfolio')}
    />
  );
};
